import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { RouterSelectSingle } from '../../filters';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { LanguageIcon } from 'foundations-assets/icons/components/LanguageIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContentLanguageSelector = ({
  language,
  availableLanguages,
  onLanguageChange
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: LanguageIcon,
      padding: "0",
      size: "600"
    }), /*#__PURE__*/_jsx(RouterSelectSingle, {
      allowList: availableLanguages,
      defaultItem: language.toUpperCase(),
      filterType: FILTER_TYPES.LANGUAGE,
      menuStyles: {
        maxBlockSize: '270px'
      },
      menuWidth: "auto",
      onFilterChange: onLanguageChange,
      trackingKey: "language-switcher"
    })]
  });
};
export default ContentLanguageSelector;